import React, { useEffect, useState } from 'react';
import TableComponent from '../../components/TableComponent/TableComponent';

const SajdahPlaces = () => {
    const [sajdahPlaces, setSajdahPlaces] = useState([]);
    useEffect(() => {
        fetch('/assets/json/sajdahPlaces.json')
            .then(response => response.json())
            .then(data => {
                setSajdahPlaces([...data]);
            });
    }, []);
    return (
        <div className="mt-5 mb-5">
            <div className="container">
                <TableComponent
                    data={sajdahPlaces}
                    heading={["No.", "Part No.", "Surah", "Verse No."]}
                    keyInfo={["No.", "Part No.", "Surah", "Verse No."]}
                />
                <p>
                    * In all, fourteen (14) places of prostration are agreed upon by all Muslim religious scholars and Ulamā, while Imām Shāfi'ī suggests prostration at this place (22:77).
                    <br />
                    <br />
                    The following invocation is usually recited during the prostration:
                    Sajada wajhiya lilladhī khalaqahu. wa shaqqa sam`ahu wa baṣarahu biḥawlihi wa quwwatihi. Fatabārakallāhu 'aḥsanul-khāliqīn. (At-Tirmidhi 2/474, Ahmad 6/30, and Al-Hakim Hisnul Muslim 50)
                    <br />
                    <br />
                    سَجَـدَ وَجْهـي للَّـذي خَلَقَـهُ وَشَقَّ سَمْـعَـهُ وَبَصَـرَهُ بِحَـوْلِـهِ وَقُـوَّتِهِ ﴿فتَبـارَكَ اللهُ أَحْسَـنُ الخـالِقيـن
                    <br />
                    <br />
                    I have prostrated my face to the One Who created it, and gave it hearing and sight by His might and His power. Glory is to Allah, the Best of creators.
                </p>
            </div>
        </div>
    );
};

export default SajdahPlaces;